import { SHARED } from './conversion-constants';
import { SlopeAngleFormat } from '@trimble/types';
import { BaseConverterProps } from './base-converter-props.types';
import { UnreachableCaseError } from 'ts-essentials';

/**
 * If converting from degrees, the output will be limited to the range equivalent to [-90, 90] degrees.
 * This is due to the application of the tangent or arctangent function in the conversion process.
 */
export const mapToPercent = ({
  value,
  baseUnit,
}: BaseConverterProps<number, SlopeAngleFormat>): number | null => {
  switch (baseUnit) {
    case 'degrees':
      return SHARED.SLOPE.degreesToRatio(value) * SHARED.SLOPE.ratioToPercent;
    case 'percentage':
      return value;
    case 'ratio':
      return value * SHARED.SLOPE.ratioToPercent;
    default:
      throw new UnreachableCaseError(baseUnit);
  }
};

/**
 * The output will be limited to the range [-90, 90] degrees.
 * This is due to the application of the tangent or arctangent function in the conversion process.
 */
export const mapToDegrees = ({
  value,
  baseUnit,
}: BaseConverterProps<number, SlopeAngleFormat>): number | null => {
  switch (baseUnit) {
    case 'degrees':
      return value;
    case 'percentage':
      return SHARED.SLOPE.ratioToDegrees(value * SHARED.SLOPE.percentToRatio);
    case 'ratio':
      return SHARED.SLOPE.ratioToDegrees(value);
    default:
      throw new UnreachableCaseError(baseUnit);
  }
};

/**
 * If converting from degrees, the output will be limited to the range equivalent to [-90, 90] degrees.
 * This is due to the application of the tangent or arctangent function in the conversion process.
 */
export const mapToRatio = ({
  value,
  baseUnit,
}: BaseConverterProps<number, SlopeAngleFormat>): number | null => {
  switch (baseUnit) {
    case 'degrees':
      return SHARED.SLOPE.degreesToRatio(value);
    case 'percentage':
      return value * SHARED.SLOPE.percentToRatio;
    case 'ratio':
      return value;
    default:
      throw new UnreachableCaseError(baseUnit);
  }
};
